import React from 'react';

import { Button, Divider, Icon, Text } from '@rbilabs/universal-components';

import { IItem } from '@rbi-ctg/menu';
import { DebugToolModal, useDebugToolPosVendor } from 'components/debug-tool';

import { SelectedItemDebug } from '../components/selected-item-debug';

interface IAddExtraDebugMenuModal {
  addOn: IItem;
  onClose: () => void;
}

const AddExtrasDebugModal: React.FC<IAddExtraDebugMenuModal> = ({ addOn, onClose }) => {
  const { storePosVendor } = useDebugToolPosVendor();

  return (
    <DebugToolModal onOpenEventMessage="Menu Debug Tool: Add Condiments" onClose={onClose}>
      <SelectedItemDebug
        selectedItemVendorConfig={addOn}
        productName={addOn.name.locale}
        posVendor={storePosVendor}
        selectedItemType={addOn._type}
      />
      <Divider />
    </DebugToolModal>
  );
};

export const AddExtrasDebug = ({ addOn }: { addOn?: IItem } = {}) => {
  const [isDebugMenuModalOpen, setIsDebugMenuModalOpen] = React.useState(false);

  return (
    <>
      <Button
        variant="ghost"
        onPress={() => setIsDebugMenuModalOpen(true)}
        leftIcon={<Icon name="mi:bug-report" />}
      >
        <Text>View Condiments info</Text>
      </Button>

      {isDebugMenuModalOpen && addOn ? (
        <AddExtrasDebugModal onClose={() => setIsDebugMenuModalOpen(false)} addOn={addOn} />
      ) : null}
    </>
  );
};
